import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
function initialsOf(name: string) {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2);
}
function TestimonialCard({
  name,
  role,
  quote
}: {
  name: string;
  role: string;
  quote: string;
}) {
  return <figure className="flex w-[300px] flex-none flex-col rounded-2xl border border-brand-medium/15 bg-white p-5 shadow-sm sm:w-[360px]" data-id="element-9" data-mp="2jekjpq6a6uiw">
      <div className="flex items-center gap-1" aria-label="5 out of 5 stars" data-id="element-10" data-mp="1qqezd4j537jl">
        {Array.from({
        length: 5
      }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-11" data-mp="1vozq8dci4evd" data-mpi={index} />)}
      </div>
      <QuoteIcon className="mt-3 h-5 w-5 text-brand-medium/40" aria-hidden="true" data-id="element-12" data-mp="131ngj3rfw1jh" />
      <blockquote className="mt-2 flex-1 text-[15px] leading-relaxed text-slate-700" data-id="element-13" data-mp="17zf63r4m3bki">
        {quote}
      </blockquote>
      <figcaption className="mt-auto flex items-center gap-3 border-t border-brand-medium/10 pt-4" data-id="element-14" data-mp="2v03zc8i29k0s">
        <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-brand-deep font-display text-sm font-bold text-white" aria-hidden="true" data-id="element-15" data-mp="2r13hotbbknfd">
          {initialsOf(name)}
        </span>
        <span data-id="element-16" data-mp="2h864n2p3jqo5">
          <span className="block text-sm font-black text-brand-deep" data-id="element-17" data-mp="2cany1iyjxnjb">
            {name}
          </span>
          <span className="block text-xs font-bold text-brand-medium" data-id="element-18" data-mp="27bbb6y7okggq">
            {role}
          </span>
        </span>
      </figcaption>
    </figure>;
}
export function TestimonialMarquee() {
  return <div className="marquee relative overflow-hidden" role="region" aria-label="Buyer reviews" data-id="element-19" data-mp="1ybwkpyrik5w8">
      <div className="marquee-track flex w-max gap-4 py-1" data-id="element-20" data-mp="1hjozthozgvi">
        {[0, 1].map(copy => <div key={copy} className="flex gap-4" aria-hidden={copy === 1} data-id="element-21" data-mp="3sq7780kmynyu">
            {testimonials.map(testimonial => <TestimonialCard key={testimonial.name} {...testimonial} data-id="element-22" data-mp="fn3j54xkmlyf" />)}
          </div>)}
      </div>
    </div>;
}